export const getElementPositionByPointer = function (
  e: any,
  offset: number = 500,
  startFromBottom: boolean = false
) {
  let x = 0,
    y = 0,
    offsetX = 0,
    offsetY = 0;

  let [top, right, bottom, left] = ['auto', 'auto', 'auto', 'auto'];
  const node = e.target as HTMLElement;
  const padding = 11; // similar to popover positioning
  const side = startFromBottom ? 30 : 0; // 30 is value in px to move dropdown to side
  const bottomGap = 30; // 30 is value in px to move dropdown from bottom
  if (e.touches) {
    ({ clientX: x, clientY: y } = e.touches[0]);
    const { left, top } = node.getBoundingClientRect();
    offsetX = x - left;
    offsetY = y - top;
  } else {
    ({ x, y, offsetX, offsetY } = e);
  }

  if (x + offset > window.innerWidth) {
    right = `${window.innerWidth - x - node.offsetWidth + offsetX + side}px`;
  } else {
    left = `${x - offsetX + side}px`;
  }
  if (y + offset + bottomGap > window.innerHeight) {
    // if flag startFromBottom is true set bottom to 16px - this is to prevent dropdown from being too close to the bottom of the screen
    bottom = startFromBottom ? '16px' : `${window.innerHeight - y + offsetY + padding}px`;
  } else {
    // if flag startFromBottom is true set top next to element - this is to prevent dropdown from too far from the button
    top = startFromBottom
      ? `${y - offsetY - padding}px`
      : `${y + node.offsetHeight - offsetY + padding}px`;
  }

  return {
    top,
    right,
    bottom,
    left,
  };
};

export default {
  getElementPositionByPointer,
};
